export const environment = {
  production: false,
  baseUrl: '',
  useHash: false,
  hmr: false,
  showThemeToggle: true,
  translateText: false,
  collapsibleSidebar: false,
  useAppInsights: false,
  appInsightsInstrumentationKey: 'e6f30bb6-a160-4d69-a8d2-8642430020c1',
  useTimeout: true,
  idleInterval: 1800,
  build: 'Test',
  version: '3.0.11',
  displaySidebar: true,
  displayHemotech: true,
  displayHospitals: true,
  theme: 'light',
  publicApi: 'https://test-staff-hflclicensing.oregon.gov/api/public/',
  privateApi: 'https://test-staff-hflclicensing.oregon.gov/api/private/',
  canManageB2CUsers: false,
  auth: {
    defaultAuth: "AAD",
    useAdIdentity: false,
    aad: {
      clientId: '38150da9-a5c7-4944-98e0-3985b780136e',
      scopes: ['api://38150da9-a5c7-4944-98e0-3985b780136e/user.access'],
      groups: [],
      authority: 'https://login.microsoftonline.com/658e63e8-8d39-499c-8f48-13adc9452f4c/',
      redirectUri: 'https://test-staff-hflclicensing.oregon.gov/',
    }
  },
  enableHttpsRedirect: true,
  staffInbox: "anthony.dunaway@odhsoha.oregon.gov",
  censusApiKey: '1c9b1ec7b5c1a33e2e28e30c5235d268d79b0e43'
};
